/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, OnInit } from '@angular/core';
import { RequestFormService } from 'src/app/home/services/request-form.service';
import { DataSelected, ValoresFormulario } from '../../utils/interfaces/summary.interface';
import { RequestUtilsService } from '../../utils/request-admin-utils.service';
import { CommmonService } from 'src/app/utils/common.service';

@Component({
  selector: 'app-summary-medical-credit',
  templateUrl: './summary-medical-credit.component.html',
  styleUrls: ['./summary-medical-credit.component.scss'],
})
export class SummaryMedicalCreditComponent implements OnInit {
  @Input() selectedOption!: string;
  @Input() summarydata!: any;
  @Input() id_solicitud!: number;
  @Input() id_beneficio!:number;
  storageData: DataSelected[] = [];
  correctionMedicalCredit = false;
  openModalApprovedMedicalCredit = false;
  messageTooltipMedicalCredit = false;

  archivos: ValoresFormulario[] = [];
  seccionArchivosVisible = false;
  titular: any;
  beneficiarios!: any[];
  isAdmin=false;
  superAdmin=false
  spinner=false;

  constructor(
    private requestFormService: RequestFormService,
    public request_utils:RequestUtilsService,
    private common_service: CommmonService,
  ) {
  }


    ngOnInit() {
      const active_user = JSON.parse(this.common_service.getItemSessionStorage('id_token_claims_obj') ?? '{}');
    this.isAdmin = active_user.roles && active_user.roles.some((role: any) => role.startsWith('ADMIN_'));   
    this.superAdmin = active_user.roles && active_user.roles.includes('SUPER_ADMIN');
      this.titular = {
        rut: `${this.summarydata.tabla_datos[0]['Rut Titular']}- ${this.summarydata.tabla_datos[0]['Dv']}`,
        nombre: this.summarydata.tabla_datos[0]['Nombre Titular'],
        email: this.summarydata.tabla_datos[0]['emailCorporativo'],
        bono:this.summarydata.tabla_datos[0]['Tipo Movimiento'],
      };
      this.beneficiarios = this.summarydata.tabla_datos;
      this.archivosDescargar()
    }


  
   archivosDescargar(){
    if(!('archivos' in this.summarydata)){
      this.summarydata['archivos'] = [];
    }
    this.archivos = this.summarydata['archivos'];

    if (this.archivos.length > 0) {
      this.seccionArchivosVisible = true; 
    } else {
      this.seccionArchivosVisible = false;
    }
  }


    buttonCorrectMedicalCredit() {
      if (this.selectedOption === 'Enviada') {
        window.scrollTo(0, 0);
        this.openModalApprovedMedicalCredit = true;
      } else {
          this.messageTooltipMedicalCredit = true;
          window.scrollTo(0, 0);
        }
      }    
  
  
   async savedApprobedMedicalCredit(data: { status: string; motivo: string }) {   
    this.spinner = true;
    try {
      const response = await this.requestFormService.putApplicationStatusUpdate(
        this.summarydata,
        2,
        this.id_solicitud,
        this.id_beneficio,
        data.motivo
      );
      if (response) {
        this.spinner = false;
      }
    } catch (error) {
      alert('Su solicitud no ha podido procesarse de forma correcta, contáctese con el área de soporte.');
      this.spinner = false;
      window.location.reload();
    }
  }

  async savedCorrectionMedicalCredit(data: { status: string; reasonList: any }) {
    this.spinner = true;
    try {
      // Set correction info
      this.summarydata.atributos_corregir = this.summarydata.atributos_corregir || {};
      this.summarydata.atributos_corregir.motivo_correccion = data.reasonList.motivo;
      this.summarydata.atributos_corregir.comentario_correccion = data.reasonList.comentario;
      this.summarydata.atributos_corregir.campos_corregir = this.storageData;

      const response = await this.requestFormService.putApplicationStatusUpdate(
        this.summarydata,
        4, // status for corrections
        this.id_solicitud,
        this.id_beneficio
      );
      
      if (response) {
        this.correctionMedicalCredit = false;
        // Optionally: close modal or emit status
      }
    } catch (error) {
      alert('No se pudo actualizar la solicitud en estado de corrección. Intente nuevamente o contacte a soporte.');
    } finally {
      this.spinner = false;
    }
  }

  
    closeModalMedicalCredit(event: boolean) {
        this.openModalApprovedMedicalCredit = event;
    }
  

  
    getIconStatusMedicalCredit(): any {
      if(this.selectedOption !== 'Enviada'){
        this.correctionMedicalCredit = false;
      } 
     return this.request_utils.get_icon_status(this.selectedOption)
    }
  
  
  }
